import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import useIntersection from 'ggApp/shared/hooks/useIntersection';
import useFetchAccessories from 'ggApp/shared/hooks/useFetchAccessories';

import WhatsInTheBox from './WhatsInTheBox';

const WhatsInTheBoxContainer = ({ accessoriesNames, language, ...props }) => {
    const {
        loading,
        accessories,
        fetchAccessories,
        loaded,
        reset: resetAccessories,
    } = useFetchAccessories();
    const nodeRef = useRef(null);

    useEffect(() => {
        resetAccessories();
    }, [resetAccessories, accessoriesNames]);

    const fetchAccessoriesByNames = useCallback(() => {
        if (loading || loaded) {
            return;
        }
        fetchAccessories(accessoriesNames, language);
    }, [loading, loaded, fetchAccessories, accessoriesNames, language]);

    useIntersection({
        node: nodeRef,
        onEnterCallback: fetchAccessoriesByNames,
        options: { threshold: 0.2 },
    });

    if (!accessoriesNames.length) return null;

    return (
        <WhatsInTheBox
            {...props}
            amountOfItems={accessoriesNames.length}
            cards={accessories}
            loading={loading || !loaded}
            nodeRef={nodeRef}
        />
    );
};

WhatsInTheBoxContainer.propTypes = {
    language: PropTypes.string,
    accessoriesNames: PropTypes.arrayOf(PropTypes.string),
};

WhatsInTheBoxContainer.defaultProps = {
    accessoriesNames: [],
    language: 'de',
};

export default WhatsInTheBoxContainer;
